var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row" }, [
    _c("div", { staticClass: "container" }, [
      _vm.title || _vm.cta
        ? _c("div", { staticClass: "mb-40 d-flex flex-wrap w-100" }, [
            _vm.title
              ? _c("h3", {
                  staticClass: "title",
                  domProps: { innerHTML: _vm._s(_vm.title) }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.cta
              ? _c(
                  "a",
                  {
                    staticClass: "ml-auto my-auto link-arrow",
                    attrs: { href: _vm.route("nl.activities") }
                  },
                  [
                    _vm._v(_vm._s(_vm.cta) + " "),
                    _c("span", {
                      staticClass: "arrow-right",
                      domProps: { innerHTML: _vm._s(_vm.svg("arrow-right")) }
                    })
                  ]
                )
              : _vm._e()
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.activities
        ? _c(
            "div",
            { staticClass: "activities-slider" },
            _vm._l(Math.round(_vm.activities.length / 2), function(col) {
              return _c(
                "div",
                { key: col },
                [
                  _c("activity-card", {
                    staticClass: "activity-card mb-40",
                    attrs: {
                      activity: _vm.maybeGetActivity(col - 1),
                      ratio: _vm.ratio
                    }
                  }),
                  _vm._v(" "),
                  _c("activity-card", {
                    staticClass: "activity-card mb-40",
                    attrs: {
                      activity: _vm.maybeGetActivity(
                        col - 1 + Math.round(_vm.activities.length / 2)
                      ),
                      ratio: _vm.ratio
                    }
                  })
                ],
                1
              )
            }),
            0
          )
        : _vm._e()
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }